// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopAssignedCustomerControllerDetachAssignedCustomerFromCustodianData } from './EshopAssignedCustomerControllerDetachAssignedCustomerFromCustodianData.gen';
import type { EshopAssignedCustomerControllerDetachAssignedCustomerFromCustodianErrors } from './EshopAssignedCustomerControllerDetachAssignedCustomerFromCustodianErrors.gen';
import type { EshopAssignedCustomerControllerDetachAssignedCustomerFromCustodianResponses } from './EshopAssignedCustomerControllerDetachAssignedCustomerFromCustodianResponses.gen';
import type { Options } from './Options.gen';

export class EshopAssignedCustomerController {
    /**
     * Detach assigned customer from their custodian, which will delete the assigned account link, customer's parentId, and disable mobile-only access
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **CUSTODIAN_REMOVAL_NOT_ALLOWED** - Custodian removal is not allowed due to customer age restrictions.<br>
     * + **INVALID_CUSTOMER** - Customer does not exist, belongs to another account, is a draft or origin.<br>
     * + **INVALID_ACCOUNT** - Account does not exist or another customer is assigned to this account.<br>
     * + **ASSIGN_CUSTODIAN_IS_NOT_ALLOWED** - Assign customer is not allowed in system configuration<br>
     * + **CUSTOMER_CREATION_UNDER_15_YEARS_NOT_ALLOWED** - Customer creation under 15 years is not allowed in system configuration.
     */
    public static detachAssignedCustomerFromCustodian<ThrowOnError extends boolean = false>(options: Options<EshopAssignedCustomerControllerDetachAssignedCustomerFromCustodianData, ThrowOnError>) {
        return (options.client ?? client).delete<EshopAssignedCustomerControllerDetachAssignedCustomerFromCustodianResponses, EshopAssignedCustomerControllerDetachAssignedCustomerFromCustodianErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customers/assigned/{id}/custodian',
            ...options
        });
    }
}
